import { generateEntityKey } from "@src/presentation/pages/Organizations/utils/addEditFormUtils";

export const PRODUCT_CATEGORY_KEY_ALREADY_EXISTS_MESSAGE =
  "This Category Key already exists.";

/** Used only for name → key auto-fill (strip non A–Z / hyphen). */
export const PRODUCT_CATEGORY_KEY_CHARS = /[^A-Z-]/g;

export const PRODUCT_CATEGORY_KEY_MAX_LENGTH = 255;

export const PRODUCT_CATEGORY_KEY_PATTERN = /^[A-Z]+(-[A-Z]+)*$/;

export const PRODUCT_CATEGORY_KEY_FORMAT_MESSAGE =
  "Only uppercase letters and hyphens are allowed";

function getMutationErrorMessage(error: unknown): string {
  return error instanceof Error ? error.message.trim() : "";
}

export function isProductCategoryKeyDuplicateError(error: unknown): boolean {
  const normalized = getMutationErrorMessage(error).toLowerCase();
  return (
    normalized.includes("category key") ||
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  );
}

/** Auto-fill Category Key from Category Name (org-key style). */
export function generateProductCategoryKeyFromName(name: string): string {
  return generateEntityKey(
    name,
    PRODUCT_CATEGORY_KEY_CHARS,
    PRODUCT_CATEGORY_KEY_MAX_LENGTH,
  );
}

export function createProductCategoryKeyRules() {
  return [
    { required: true, message: "Category key is required" },
    {
      pattern: PRODUCT_CATEGORY_KEY_PATTERN,
      message: PRODUCT_CATEGORY_KEY_FORMAT_MESSAGE,
    },
    {
      max: PRODUCT_CATEGORY_KEY_MAX_LENGTH,
      message: `Category key must be less than or equal to ${PRODUCT_CATEGORY_KEY_MAX_LENGTH} characters.`,
    },
  ];
}
